export interface User {
  userId: string;
  email: string;
  permissions: string[];
  groups: string[];
  deletedAt?: string;
  createdBy?: string;
  authenticatorEnabled: boolean;
}

export interface NewUser extends User {
  userId: 'new';
}

export const isNewUser = (u: User | NewUser): u is NewUser => {
  return u.userId === 'new';
};

export interface Role {
  name: string;
  permissions: string[];
}

export const isNewRole = (r: Role) => {
  return r.name === 'new';
};
